export default __webpack_public_path__ + "static/media/mona.3187827d.svg";